export default "__VITE_ASSET__BVQtJ1aA__"